export default [
    {
        name: 'Point Tool',
        displayName: 'Point',
        icon: 'fas fa-circle',
        mode: 'DrawPointGPS',
        description: 'Click the map to create a point.',
    },
    {
        name: 'Line Tool',
        displayName: 'Line',
        icon: 'fas fa-horizontal-rule',
        mode: 'DrawLineGPS',
        description:
            'Click multiple times on the map to create a line. Double-click to finish the line.',
    },
    {
        name: 'Polygon Tool',
        displayName: 'Polygon',
        icon: 'fas fa-draw-polygon',
        mode: 'DrawPolygonGPS',
        description:
            'Click multiple times on the map to create a polygon. Double-click to finish the polygon.',
    },
];
